const getUsersByCompanyId = async (token: string, companyId: string) => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/${companyId}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});

	return response.json();
};

export default getUsersByCompanyId;
